import React from 'react';
import { useI18n } from '../../hooks/useI18n';
import type { SocialMediaProps } from './SocialMedia.types';
import { SOCIAL_MEDIA_ICONS, SOCIAL_MEDIA_ACCESSIBILITY } from './SocialMedia.constants';
import { StyledSocialMediaLink, StyledSocialMediaIcon } from './SocialMedia.styles';

const SocialMedia: React.FC<SocialMediaProps> = React.memo(
  ({ platform, size = 'small', url, className }) => {
    const { t } = useI18n();

    const iconSrc = SOCIAL_MEDIA_ICONS[platform];
    const ariaLabel = t(`socialMedia.${platform}`);

    return (
      <StyledSocialMediaLink
        href={url}
        target={SOCIAL_MEDIA_ACCESSIBILITY.LINK_TARGET}
        rel={SOCIAL_MEDIA_ACCESSIBILITY.LINK_REL}
        aria-label={ariaLabel}
        className={className}
        $size={size}
      >
        <StyledSocialMediaIcon src={iconSrc} alt={ariaLabel} $size={size} />
      </StyledSocialMediaLink>
    );
  },
);

SocialMedia.displayName = 'SocialMedia';

export default SocialMedia;
